import React, { Fragment } from 'react'
import { Intro, Voiceover, FlipCard } from 'cvs-core'
import img1 from '../../assets/images/U1-T1-9a.svg'
import img2 from '../../assets/images/U1-T1-9b.svg'
import img3 from '../../assets/images/U1-T1-9c.svg'
import voAudio from '../../assets/vo/Learn-Social-Consequences-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Continue to learn about the social consequences of vaping or using e-cigarettes.',
}

const data = {
  cards: [
    {
      title: 'Losing Friends',
      frontOfCard: {
        header: 'Losing Friends',
        text: <Fragment />,
        image: img1,
        imageAltText: 'Losing Friends',
      },
      backOfCard: {
        header: 'Losing Friends',
        text: (
          <Fragment>
            If you use e-cigarettes, others might decide to not hang out with
            you anymore. Your reputation could be affected, and you could be
            seen as a negative influence.
          </Fragment>
        ),
        image: img1,
        imageAltText: 'Losing Friends',
      },
    },
    {
      title: 'Breaking the Rules',
      frontOfCard: {
        header: 'Breaking the Rules',
        text: <Fragment />,
        image: img2,
        imageAltText: 'Breaking the Rules',
      },
      backOfCard: {
        header: 'Breaking the Rules',
        text: (
          <Fragment>
            Possessing e-cigarettes is against the law for anyone under 21. You
            can face school consequences, like detention or suspension which
            could show up on your record when you apply to colleges. Getting
            caught vaping, could lead to getting kicked off a team or out of a
            club.
          </Fragment>
        ),
        image: img2,
        imageAltText: 'Breaking the Rules',
      },
    },
    {
      title: 'Adult Distrust',
      frontOfCard: {
        header: 'Adult Distrust',
        text: <Fragment />,
        image: img3,
        imageAltText: 'Adult Distrust',
      },
      backOfCard: {
        header: 'Adult Distrust',
        text: (
          <Fragment>
            If you vape/use e-cigarettes, the adults in your life might lose
            trust in you. You could face consequences at home like being
            grounded or getting your phone taken away.
          </Fragment>
        ),
        image: img3,
        imageAltText: 'Adult Distrust',
      },
    },
  ],
}

export default {
  title: 'Social Consequences',
  path: '/learn/social-consequences',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Social Consequences"
        direction="Flip each card to learn more."
        lead="Flip each card to learn about the social consequences of vaping/using e-cigarettes."
      />
      <FlipCard data={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/SocialConsequences.js